import { ComponentPropsWithoutRef } from 'react'

export function CloseIcon(props: ComponentPropsWithoutRef<'svg'>) {
  return (
    <svg
      viewBox="0 0 14 14"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M13.7074 0.3025C13.3174 -0.0874998 12.6874 -0.0874998 12.2974 0.3025L7.40744 5.1825L2.51744 0.2925C2.12744 -0.0975 1.49744 -0.0975 1.10744 0.2925C0.717441 0.6825 0.717441 1.3125 1.10744 1.7025L5.99744 6.5925L1.10744 11.4825C0.717441 11.8725 0.717441 12.5025 1.10744 12.8925C1.49744 13.2825 2.12744 13.2825 2.51744 12.8925L7.40744 8.0025L12.2974 12.8925C12.6874 13.2825 13.3174 13.2825 13.7074 12.8925C14.0974 12.5025 14.0974 11.8725 13.7074 11.4825L8.81744 6.5925L13.7074 1.7025C14.0874 1.3225 14.0874 0.6825 13.7074 0.3025Z"
        fill="currentColor"
      />
    </svg>
  )
}

export function AlertIcon(props: ComponentPropsWithoutRef<'svg'>) {
  return (
    <svg
      viewBox="0 0 24 21"
      fill="currentColor"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M3.49999 21.0004C2.99999 21.0004 2.49999 20.9004 1.99999 20.6004C0.599987 19.8004 0.0999871 17.9004 0.899987 16.5004L9.39999 2.30039C9.69999 1.90039 9.99999 1.50039 10.4 1.30039C11.1 0.900391 11.9 0.800391 12.7 1.00039C13.5 1.20039 14.1 1.70039 14.6 2.40039L23 16.5004C23.3 17.0004 23.4 17.5004 23.4 18.0004C23.4 18.8004 23.1 19.6004 22.5 20.1004C22 20.7004 21.3 21.0004 20.5 21.0004H3.49999ZM11.1 3.40039L2.69999 17.5004C2.39999 18.0004 2.59999 18.6004 3.09999 18.9004C3.19999 19.0004 3.39999 19.0004 3.49999 19.0004H20.4C20.7 19.0004 20.9 18.9004 21.1 18.7004C21.3 18.5004 21.4 18.3004 21.4 18.0004C21.4 17.8004 21.4 17.7004 21.3 17.5004L12.9 3.40039C12.6 2.90039 12 2.80039 11.5 3.00039C11.3 3.10039 11.2 3.20039 11.1 3.40039Z"
        fill="currentColor"
      />
      <path
        d="M12 13.0004C11.4 13.0004 11 12.6004 11 12.0004V8.00039C11 7.40039 11.4 7.00039 12 7.00039C12.6 7.00039 13 7.40039 13 8.00039V12.0004C13 12.6004 12.6 13.0004 12 13.0004Z"
        fill="currentColor"
      />
      <path
        d="M12 17.0004C11.7 17.0004 11.5 16.9004 11.3 16.7004C11.1 16.5004 11 16.3004 11 16.0004C11 15.9004 11 15.7004 11.1 15.6004C11.2 15.5004 11.2 15.4004 11.3 15.3004C11.4 15.2004 11.5 15.1004 11.6 15.1004C11.8 15.0004 12 15.0004 12.2 15.0004C12.3 15.0004 12.3 15.0004 12.4 15.1004C12.5 15.1004 12.5 15.1004 12.6 15.2004C12.6 15.2004 12.7 15.3004 12.8 15.3004C12.9 15.4004 13 15.5004 13 15.6004C13 15.7004 13.1 15.9004 13.1 16.0004C13.1 16.3004 13 16.5004 12.8 16.7004C12.5 16.9004 12.3 17.0004 12 17.0004Z"
        fill="currentColor"
      />
    </svg>
  )
}
